(function (global) {
  'use strict';

  var VERSION = '2.0.1';
  var TIME_ZONE = 'Asia/Shanghai';
  var SHANGHAI_OFFSET_MS = 8 * 60 * 60 * 1000;
  var DAY_IN_MS = 24 * 60 * 60 * 1000;

  if (global.QiyuanObservanceCalendar && global.QiyuanObservanceCalendar.version) return;

  var TYPES = {
    duanwu: {
      englishTitle: 'Dragon Boat Festival · Duanwu',
      chineseTitle: '端午节',
      introduction: 'A seasonal day for family care, shared traditions, and thoughtful wishes for health and peace.',
      imageKey: 'lotus',
      imageAlt: 'A warm lotus lamp for seasonal family care',
      articleUrl: '/pages/dragon-boat-duanwu',
      primaryCtaLabel: 'Learn About Duanwu',
      secondaryCtaLabel: 'Explore Family Care',
      secondaryCtaUrl: '/pages/dragon-boat-duanwu',
    },

    spring_festival: {
      englishTitle: 'Spring Festival · Lunar New Year',
      chineseTitle: '春节 · 农历新年',
      introduction: 'A season of family reunion, renewal, ancestor gratitude, and wishes for a peaceful year.',
      imageKey: 'lotus',
      imageAlt: 'A warm lotus lamp for Lunar New Year family remembrance',
      articleUrl: '/pages/lunar-new-year-spring-festival',
      primaryCtaLabel: 'Learn About the Festival',
      secondaryCtaLabel: 'Send a Family Wish',
      secondaryCtaUrl: '/pages/start-memorial?step=3&for=for_family&purpose=legacy&source=lunar-new-year',
    },
    nirvana_day: {
      englishTitle: 'Shakyamuni Buddha’s Nirvana Day',
      chineseTitle: '释迦牟尼佛涅槃日',
      introduction: 'A day associated with impermanence, reflection, remembrance, and gratitude.',
      imageKey: 'lotus',
      imageAlt: 'A quiet lotus lamp for reflection on impermanence',
      articleUrl: '/pages/shakyamuni-buddha-s-nirvana-day',
      primaryCtaLabel: 'Learn About the Day',
      secondaryCtaLabel: 'Arrange a Remembrance',
      secondaryCtaUrl: '/pages/start-memorial?step=3&for=in_memory&purpose=memorial&theme=buddhist&source=nirvana-day',
    },
    qingming: {
      englishTitle: 'Qingming Festival',
      chineseTitle: '清明节',
      introduction: 'A seasonal day centered on ancestor remembrance, gratitude, and family memory.',
      imageKey: 'lotus',
      imageAlt: 'A lotus remembrance lamp for Qingming Festival',
      articleUrl: '/pages/qingming',
      primaryCtaLabel: 'Learn About Qingming',
      secondaryCtaLabel: 'Create a Memorial',
      secondaryCtaUrl: '/pages/start-memorial?step=3&for=in_memory&purpose=memorial&theme=heritage&source=qingming',
    },
    guanyin_birthday: {
      englishTitle: 'Guanyin Bodhisattva Birthday',
      chineseTitle: '观音菩萨圣诞日',
      introduction: 'A day associated with compassion, care, kindness, and gentle wishes.',
      imageKey: 'guanyin',
      imageAlt: 'A serene Guanyin-inspired setting for compassionate reflection',
      articleUrl: '/pages/guanyin',
      primaryCtaLabel: 'Learn About the Day',
      secondaryCtaLabel: 'Enter Guanyin Hall',
      secondaryCtaUrl: '/?qy_garden=guanyin#memorial-garden',
    },
    samantabhadra: {
      englishTitle: 'Samantabhadra Bodhisattva Birthday',
      chineseTitle: '普贤菩萨圣诞日',
      introduction: 'A day associated with vows, mindful action, practice, and quiet dedication.',
      imageKey: 'lotus',
      imageAlt: 'A lotus lamp for mindful action and dedication',
      articleUrl: '/pages/samantabhadra-bodhisattva-birthday',
      primaryCtaLabel: 'Learn About the Day',
      secondaryCtaLabel: 'Arrange a Remembrance',
      secondaryCtaUrl: '/pages/start-memorial?step=3&for=in_memory&purpose=memorial&theme=buddhist&source=samantabhadra',
    },
    mazu: {
      englishTitle: 'Mazu’s Birthday · Mazu Dan',
      chineseTitle: '妈祖诞',
      introduction: 'A cultural day connected with safe journeys, overseas longing, family care, and coastal heritage.',
      imageKey: 'lotus',
      imageAlt: 'A warm lotus lamp for Mazu cultural remembrance',
      articleUrl: '/pages/mazu-birthday',
      primaryCtaLabel: 'Learn About the Day',
      secondaryCtaLabel: 'Send a Family Wish',
      secondaryCtaUrl: '/pages/start-memorial?step=3&for=for_living&purpose=blessing&source=mazu-birthday',
    },
    mothers_day: {
      englishTitle: 'Mother’s Day',
      chineseTitle: '母亲节',
      introduction: 'A day for gratitude, remembrance, and honoring mothers and mother figures near or far.',
      imageKey: 'lotus',
      imageAlt: 'A gentle lotus lamp honoring mothers and mother figures',
      articleUrl: '/pages/mothers-day-remembrance',
      primaryCtaLabel: 'Explore Mother’s Day Remembrance',
      secondaryCtaLabel: 'Create a Memorial',
      secondaryCtaUrl: '/pages/start-memorial?step=3&for=in_memory&purpose=memorial&theme=classic&source=mothers-day',
    },
    buddha_birthday: {
      englishTitle: 'Buddha’s Birthday · Vesak-Related Observance',
      chineseTitle: '佛诞日',
      introduction: 'A cultural day associated with compassion, kindness, reflection, and family remembrance.',
      imageKey: 'lotus',
      imageAlt: 'A warm lotus lamp for Buddha’s Birthday remembrance',
      articleUrl: '/pages/buddhas-birthday-vesak-day',
      primaryCtaLabel: 'Learn About the Day',
      secondaryCtaLabel: 'Arrange a Remembrance',
      secondaryCtaUrl: '/pages/start-memorial?step=3&for=in_memory&purpose=memorial&theme=buddhist&source=vesak-observance',
    },
    mahasthamaprapta: {
      englishTitle: 'Mahasthamaprapta Bodhisattva Birthday',
      chineseTitle: '大势至菩萨圣诞日',
      introduction: 'A day associated with wisdom-light, focus, and dedicated remembrance.',
      imageKey: 'lotus',
      imageAlt: 'A lotus remembrance lamp representing wisdom-light',
      articleUrl: '/pages/mahasthamaprapta-bodhisattva-birthday',
      primaryCtaLabel: 'Learn About the Day',
      secondaryCtaLabel: 'Arrange a Remembrance',
      secondaryCtaUrl: '/pages/start-memorial?step=3&for=in_memory&purpose=memorial&theme=buddhist&source=mahasthamaprapta',
    },
    laba: {
      englishTitle: 'Laba Festival · Buddha’s Enlightenment Day',
      chineseTitle: '腊八节 · 佛成道日',
      introduction: 'A day associated with gratitude, reflection, simple nourishment, and compassionate intention.',
      imageKey: 'lotus',
      imageAlt: 'A warm lotus remembrance lamp for Laba Festival',
      articleUrl: '/pages/laba-festival',
      primaryCtaLabel: 'Learn About Laba',
      secondaryCtaLabel: 'Arrange a Remembrance',
      secondaryCtaUrl: '/pages/start-memorial?step=3&for=in_memory&purpose=memorial&theme=buddhist&source=laba',
    },
    guanyin_enlightenment: {
      englishTitle: 'Guanyin Bodhisattva Enlightenment Day',
      chineseTitle: '观音菩萨成道日',
      introduction: 'A traditional day associated with compassion, attentive listening, and responding to suffering with care.',
      imageKey: 'guanyin',
      imageAlt: 'A serene Guanyin-inspired setting for a day of compassion',
      articleUrl: '/pages/guanyin-enlightenment-day',
      primaryCtaLabel: 'Learn About the Day',
      secondaryCtaLabel: 'Enter Guanyin Hall',
      secondaryCtaUrl: '/?qy_garden=guanyin#memorial-garden',
    },
    zhongyuan: {
      englishTitle: 'Zhongyuan Festival · Ullambana',
      chineseTitle: '中元节 · 盂兰盆节',
      introduction: 'A day of remembrance for departed loved ones and ancestors, including for families observing from far away.',
      imageKey: 'lotus',
      imageAlt: 'A golden lotus remembrance lamp for Zhongyuan Festival',
      articleUrl: '/pages/ghost-festival-ullambana',
      primaryCtaLabel: 'Learn About Zhongyuan',
      secondaryCtaLabel: 'Light a Remembrance Lamp',
      secondaryCtaUrl: '/?qy_garden=dizang#memorial-garden',
    },
    ksitigarbha: {
      englishTitle: 'Kṣitigarbha Bodhisattva Day',
      chineseTitle: '地藏菩萨圣诞日',
      introduction: 'A remembrance-focused day associated with compassionate vows, care for the departed, and filial gratitude.',
      imageKey: 'lotus',
      imageAlt: 'A quiet lotus remembrance lamp for Kṣitigarbha Bodhisattva Day',
      articleUrl: '/pages/ksitigarbha-bodhisattva-birthday',
      primaryCtaLabel: 'Learn About the Day',
      secondaryCtaLabel: 'Enter Kṣitigarbha Hall',
      secondaryCtaUrl: '/?qy_garden=dizang#memorial-garden',
    },
    mid_autumn: {
      englishTitle: 'Mid-Autumn Festival',
      chineseTitle: '中秋节',
      introduction: 'A family-centered day for reunion, gratitude, and remembering relatives across distance and generations.',
      imageKey: 'lotus',
      imageAlt: 'A warm lotus lamp for Mid-Autumn family remembrance',
      articleUrl: '/pages/mid-autumn-family-remembrance',
      primaryCtaLabel: 'Learn About Mid-Autumn',
      secondaryCtaLabel: 'Create a Family Remembrance',
      secondaryCtaUrl: '/pages/start-memorial?step=3&for=for_family&purpose=legacy&source=mid-autumn',
    },
    chongyang: {
      englishTitle: 'Double Ninth · Chongyang Festival',
      chineseTitle: '重阳节',
      introduction: 'A day for honoring elders, remembering family roots, and carrying care between generations.',
      imageKey: 'lotus',
      imageAlt: 'A gentle lotus lamp for Chongyang family remembrance',
      articleUrl: '/pages/double-ninth-chongyang-festival',
      primaryCtaLabel: 'Learn About Chongyang',
      secondaryCtaLabel: 'Send a Family Wish',
      secondaryCtaUrl: '/pages/start-memorial?step=3&for=for_living&purpose=blessing&source=chongyang',
    },
    guanyin_renunciation: {
      englishTitle: 'Guanyin Bodhisattva Renunciation Day',
      chineseTitle: '观音菩萨出家日',
      introduction: 'A day associated with letting go, compassion, mindful clarity, and gentle reflection.',
      imageKey: 'guanyin',
      imageAlt: 'A serene Guanyin-inspired setting for quiet reflection',
      articleUrl: '/pages/guanyin-renunciation-day',
      primaryCtaLabel: 'Learn About the Day',
      secondaryCtaLabel: 'Enter Guanyin Hall',
      secondaryCtaUrl: '/?qy_garden=guanyin#memorial-garden',
    },
    medicine_buddha: {
      englishTitle: 'Medicine Buddha Birthday',
      chineseTitle: '药师佛圣诞日',
      introduction: 'A day for reflection on care, well-being, and compassionate support for loved ones who are living.',
      imageKey: 'lotus',
      imageAlt: 'A warm lotus lamp representing care and well-being',
      articleUrl: '/pages/medicine-buddha-birthday',
      primaryCtaLabel: 'Learn About the Day',
      secondaryCtaLabel: 'Send a Wish of Care',
      secondaryCtaUrl: '/pages/start-memorial?step=3&for=for_living&purpose=blessing&theme=buddhist&source=medicine-buddha',
    },
    dongzhi: {
      englishTitle: 'Winter Solstice · Dongzhi',
      chineseTitle: '冬至',
      introduction: 'A seasonal day for family warmth, remembrance, and quiet reflection as light begins to return.',
      imageKey: 'lotus',
      imageAlt: 'A warm lotus lamp for Winter Solstice family remembrance',
      articleUrl: '/pages/winter-solstice-dongzhi',
      primaryCtaLabel: 'Learn About Dongzhi',
      secondaryCtaLabel: 'Create a Family Remembrance',
      secondaryCtaUrl: '/pages/start-memorial?step=3&for=for_family&purpose=legacy&source=dongzhi',
    },
    amitabha: {
      englishTitle: 'Amitabha Buddha Birthday',
      chineseTitle: '阿弥陀佛圣诞日',
      introduction: 'A day associated with peaceful reflection, compassionate remembrance, and sincere dedication.',
      imageKey: 'lotus',
      imageAlt: 'A golden lotus remembrance lamp for Amitabha Buddha Birthday',
      articleUrl: '/pages/amitabha-buddha-birthday',
      primaryCtaLabel: 'Learn About the Day',
      secondaryCtaLabel: 'Arrange a Remembrance',
      secondaryCtaUrl: '/pages/start-memorial?step=3&for=in_memory&purpose=memorial&theme=buddhist&source=amitabha',
    },
  };

  var SCHEDULE = [
    ['duanwu-2026', 'duanwu', '2026-06-19', 'Lunar May 5'],
    ['duanwu-2027', 'duanwu', '2027-06-09', 'Lunar May 5'],
    ['duanwu-2028', 'duanwu', '2028-05-28', 'Lunar May 5'],
    ['duanwu-2029', 'duanwu', '2029-06-16', 'Lunar May 5'],
    ['duanwu-2030', 'duanwu', '2030-06-05', 'Lunar May 5'],

    ['laba-2026', 'laba', '2026-01-26', 'Lunar December 8'],
    ['spring-festival-2026', 'spring_festival', '2026-02-17', 'Lunar January 1 · Year of the Horse'],
    ['nirvana-day-2026', 'nirvana_day', '2026-04-02', 'Lunar February 15'],
    ['qingming-2026', 'qingming', '2026-04-05', 'Qingming solar term'],
    ['guanyin-birthday-2026', 'guanyin_birthday', '2026-04-06', 'Lunar February 19'],
    ['samantabhadra-2026', 'samantabhadra', '2026-04-08', 'Lunar February 21'],
    ['mazu-2026', 'mazu', '2026-05-09', 'Lunar March 23'],
    ['mothers-day-2026', 'mothers_day', '2026-05-10', 'Second Sunday of May'],
    ['buddha-birthday-2026', 'buddha_birthday', '2026-05-24', 'Lunar April 8 in many East Asian traditions'],
    ['guanyin-enlightenment-2026', 'guanyin_enlightenment', '2026-08-01', 'Lunar June 19'],
    ['mahasthamaprapta-2026', 'mahasthamaprapta', '2026-08-25', 'Lunar July 13'],
    ['zhongyuan-2026', 'zhongyuan', '2026-08-27', 'Lunar July 15'],
    ['ksitigarbha-2026', 'ksitigarbha', '2026-09-10', 'Lunar July 29 · final day of the short seventh lunar month'],
    ['mid-autumn-2026', 'mid_autumn', '2026-09-25', 'Lunar August 15'],
    ['chongyang-2026', 'chongyang', '2026-10-18', 'Lunar September 9'],
    ['guanyin-renunciation-2026', 'guanyin_renunciation', '2026-10-28', 'Lunar September 19'],
    ['medicine-buddha-2026', 'medicine_buddha', '2026-11-08', 'Lunar September 30'],
    ['dongzhi-2026', 'dongzhi', '2026-12-22', 'Winter Solstice · East Asia calendar date'],
    ['amitabha-2026', 'amitabha', '2026-12-25', 'Lunar November 17'],

    ['laba-2027', 'laba', '2027-01-15', 'Lunar December 8'],
    ['guanyin-enlightenment-2027', 'guanyin_enlightenment', '2027-07-22', 'Lunar June 19'],
    ['zhongyuan-2027', 'zhongyuan', '2027-08-16', 'Lunar July 15'],
    ['ksitigarbha-2027', 'ksitigarbha', '2027-08-31', 'Lunar July 30'],
    ['mid-autumn-2027', 'mid_autumn', '2027-09-15', 'Lunar August 15'],
    ['chongyang-2027', 'chongyang', '2027-10-08', 'Lunar September 9'],
    ['guanyin-renunciation-2027', 'guanyin_renunciation', '2027-10-18', 'Lunar September 19'],
    ['medicine-buddha-2027', 'medicine_buddha', '2027-10-28', 'Lunar September 29 · final day of the short ninth lunar month'],
    ['amitabha-2027', 'amitabha', '2027-12-14', 'Lunar November 17'],
    ['dongzhi-2027', 'dongzhi', '2027-12-22', 'Winter Solstice · East Asia calendar date'],

    ['laba-2028', 'laba', '2028-01-04', 'Lunar December 8'],
    ['guanyin-enlightenment-2028', 'guanyin_enlightenment', '2028-08-09', 'Lunar June 19'],
    ['zhongyuan-2028', 'zhongyuan', '2028-09-03', 'Lunar July 15'],
    ['ksitigarbha-2028', 'ksitigarbha', '2028-09-18', 'Lunar July 30'],
    ['mid-autumn-2028', 'mid_autumn', '2028-10-03', 'Lunar August 15'],
    ['chongyang-2028', 'chongyang', '2028-10-26', 'Lunar September 9'],
    ['guanyin-renunciation-2028', 'guanyin_renunciation', '2028-11-05', 'Lunar September 19'],
    ['medicine-buddha-2028', 'medicine_buddha', '2028-11-15', 'Lunar September 29 · final day of the short ninth lunar month'],
    ['dongzhi-2028', 'dongzhi', '2028-12-21', 'Winter Solstice · East Asia calendar date'],

    ['amitabha-2029-january', 'amitabha', '2029-01-01', 'Lunar November 17'],
    ['laba-2029', 'laba', '2029-01-22', 'Lunar December 8'],
    ['guanyin-enlightenment-2029', 'guanyin_enlightenment', '2029-07-29', 'Lunar June 19'],
    ['zhongyuan-2029', 'zhongyuan', '2029-08-24', 'Lunar July 15'],
    ['ksitigarbha-2029', 'ksitigarbha', '2029-09-07', 'Lunar July 29 · final day of the short seventh lunar month'],
    ['mid-autumn-2029', 'mid_autumn', '2029-09-22', 'Lunar August 15'],
    ['chongyang-2029', 'chongyang', '2029-10-16', 'Lunar September 9'],
    ['guanyin-renunciation-2029', 'guanyin_renunciation', '2029-10-26', 'Lunar September 19'],
    ['medicine-buddha-2029', 'medicine_buddha', '2029-11-05', 'Lunar September 29 · final day of the short ninth lunar month'],
    ['amitabha-2029-december', 'amitabha', '2029-12-21', 'Lunar November 17'],
    ['dongzhi-2029', 'dongzhi', '2029-12-21', 'Winter Solstice · East Asia calendar date'],

    ['laba-2030', 'laba', '2030-01-11', 'Lunar December 8'],
    ['guanyin-enlightenment-2030', 'guanyin_enlightenment', '2030-07-19', 'Lunar June 19'],
    ['zhongyuan-2030', 'zhongyuan', '2030-08-13', 'Lunar July 15'],
    ['ksitigarbha-2030', 'ksitigarbha', '2030-08-28', 'Lunar July 30'],
    ['mid-autumn-2030', 'mid_autumn', '2030-09-12', 'Lunar August 15'],
    ['chongyang-2030', 'chongyang', '2030-10-05', 'Lunar September 9'],
    ['guanyin-renunciation-2030', 'guanyin_renunciation', '2030-10-15', 'Lunar September 19'],
    ['medicine-buddha-2030', 'medicine_buddha', '2030-10-26', 'Lunar September 30'],
    ['amitabha-2030', 'amitabha', '2030-12-11', 'Lunar November 17'],
    ['dongzhi-2030', 'dongzhi', '2030-12-22', 'Winter Solstice · East Asia calendar date'],
    ['amitabha-2026-january', 'amitabha', '2026-01-05', 'Lunar November 17'],
    ['spring-festival-2027', 'spring_festival', '2027-02-06', 'Lunar January 1'],
    ['nirvana-day-2027', 'nirvana_day', '2027-03-22', 'Lunar February 15'],
    ['guanyin-birthday-2027', 'guanyin_birthday', '2027-03-26', 'Lunar February 19'],
    ['samantabhadra-2027', 'samantabhadra', '2027-03-28', 'Lunar February 21'],
    ['qingming-2027', 'qingming', '2027-04-05', 'Qingming solar term'],
    ['mazu-2027', 'mazu', '2027-04-29', 'Lunar March 23'],
    ['mothers-day-2027', 'mothers_day', '2027-05-09', 'Second Sunday of May'],
    ['buddha-birthday-2027', 'buddha_birthday', '2027-05-13', 'Lunar April 8 in many East Asian traditions'],
    ['mahasthamaprapta-2027', 'mahasthamaprapta', '2027-08-14', 'Lunar July 13'],
    ['spring-festival-2028', 'spring_festival', '2028-01-26', 'Lunar January 1'],
    ['nirvana-day-2028', 'nirvana_day', '2028-03-10', 'Lunar February 15'],
    ['guanyin-birthday-2028', 'guanyin_birthday', '2028-03-14', 'Lunar February 19'],
    ['samantabhadra-2028', 'samantabhadra', '2028-03-16', 'Lunar February 21'],
    ['qingming-2028', 'qingming', '2028-04-04', 'Qingming solar term'],
    ['mazu-2028', 'mazu', '2028-04-17', 'Lunar March 23'],
    ['buddha-birthday-2028', 'buddha_birthday', '2028-05-02', 'Lunar April 8 in many East Asian traditions'],
    ['mothers-day-2028', 'mothers_day', '2028-05-14', 'Second Sunday of May'],
    ['mahasthamaprapta-2028', 'mahasthamaprapta', '2028-09-01', 'Lunar July 13'],
    ['spring-festival-2029', 'spring_festival', '2029-02-13', 'Lunar January 1'],
    ['nirvana-day-2029', 'nirvana_day', '2029-03-29', 'Lunar February 15'],
    ['guanyin-birthday-2029', 'guanyin_birthday', '2029-04-02', 'Lunar February 19'],
    ['samantabhadra-2029', 'samantabhadra', '2029-04-04', 'Lunar February 21'],
    ['qingming-2029', 'qingming', '2029-04-04', 'Qingming solar term'],
    ['mazu-2029', 'mazu', '2029-05-06', 'Lunar March 23'],
    ['mothers-day-2029', 'mothers_day', '2029-05-13', 'Second Sunday of May'],
    ['buddha-birthday-2029', 'buddha_birthday', '2029-05-20', 'Lunar April 8 in many East Asian traditions'],
    ['mahasthamaprapta-2029', 'mahasthamaprapta', '2029-08-22', 'Lunar July 13'],
    ['spring-festival-2030', 'spring_festival', '2030-02-03', 'Lunar January 1'],
    ['nirvana-day-2030', 'nirvana_day', '2030-03-18', 'Lunar February 15'],
    ['guanyin-birthday-2030', 'guanyin_birthday', '2030-03-22', 'Lunar February 19'],
    ['samantabhadra-2030', 'samantabhadra', '2030-03-24', 'Lunar February 21'],
    ['qingming-2030', 'qingming', '2030-04-05', 'Qingming solar term'],
    ['mazu-2030', 'mazu', '2030-04-25', 'Lunar March 23'],
    ['buddha-birthday-2030', 'buddha_birthday', '2030-05-09', 'Lunar April 8 in many East Asian traditions'],
    ['mothers-day-2030', 'mothers_day', '2030-05-12', 'Second Sunday of May'],
    ['mahasthamaprapta-2030', 'mahasthamaprapta', '2030-08-11', 'Lunar July 13'],
  ];

  function parseISODate(value) {
    if (typeof value !== 'string') return null;
    var match = /^(\d{4})-(\d{2})-(\d{2})$/.exec(value);
    if (!match) return null;
    var year = Number(match[1]);
    var month = Number(match[2]);
    var day = Number(match[3]);
    var ms = Date.UTC(year, month - 1, day);
    var date = new Date(ms);
    if (date.getUTCFullYear() !== year || date.getUTCMonth() !== month - 1 || date.getUTCDate() !== day) return null;
    return { key: value, year: year, month: month, date: day, day: ms / DAY_IN_MS, utcMs: ms };
  }

  function dateKeyFromUTC(date) {
    return [
      String(date.getUTCFullYear()).padStart(4, '0'),
      String(date.getUTCMonth() + 1).padStart(2, '0'),
      String(date.getUTCDate()).padStart(2, '0'),
    ].join('-');
  }

  function getTodayKey(now, timeZone) {
    var date = now instanceof Date ? new Date(now.getTime()) : new Date(now === undefined ? Date.now() : now);
    if (Number.isNaN(date.getTime())) return null;
    try {
      var parts = {};
      new Intl.DateTimeFormat('en-US-u-ca-gregory-nu-latn', {
        timeZone: timeZone || TIME_ZONE,
        year: 'numeric',
        month: '2-digit',
        day: '2-digit',
      }).formatToParts(date).forEach(function (part) {
        if (part.type === 'year' || part.type === 'month' || part.type === 'day') parts[part.type] = part.value;
      });
      var key = [parts.year, parts.month, parts.day].join('-');
      if (parseISODate(key)) return key;
    } catch (error) {
      // Asia/Shanghai has no daylight-saving transition; use the fixed UTC+8 fallback below.
    }
    return dateKeyFromUTC(new Date(date.getTime() + SHANGHAI_OFFSET_MS));
  }

  function isSafeLocalUrl(value) {
    return typeof value === 'string' && /^\/(?!\/)/.test(value) && !/[\\\s\u0000-\u001f]/.test(value);
  }

  function validEvent(event) {
    return Boolean(
      event &&
      event.enabled === true &&
      event.id &&
      parseISODate(event.date) &&
      event.englishTitle &&
      event.chineseTitle &&
      event.introduction &&
      (event.imageKey === 'lotus' || event.imageKey === 'guanyin') &&
      event.imageAlt &&
      event.primaryCtaLabel &&
      event.secondaryCtaLabel &&
      isSafeLocalUrl(event.primaryCtaUrl) &&
      isSafeLocalUrl(event.secondaryCtaUrl)
    );
  }

  function inDisplayWindow(event, todayDay) {
    var start = event.displayStart ? parseISODate(event.displayStart) : null;
    var end = event.displayEnd ? parseISODate(event.displayEnd) : null;
    if ((event.displayStart && !start) || (event.displayEnd && !end)) return false;
    if (start && todayDay < start.day) return false;
    if (end && todayDay > end.day) return false;
    return true;
  }

  function selectNextEvent(records, options) {
    var settings = options || {};
    var todayKey = settings.todayKey || getTodayKey(settings.now, settings.timeZone || TIME_ZONE);
    var today = parseISODate(todayKey);
    if (!today) return null;
    return (records || events)
      .filter(function (event) {
        var date = validEvent(event) ? parseISODate(event.date) : null;
        return date && date.day >= today.day && inDisplayWindow(event, today.day);
      })
      .slice()
      .sort(function (left, right) {
        return parseISODate(left.date).day - parseISODate(right.date).day || left.order - right.order || left.id.localeCompare(right.id);
      })[0] || null;
  }

  function statusFor(event, todayKey) {
    var eventDate = event && parseISODate(event.date);
    var today = parseISODate(todayKey);
    if (!eventDate || !today) return 'Unknown';
    if (eventDate.day === today.day) return 'Today';
    return eventDate.day > today.day ? 'Upcoming' : 'Past';
  }

  function visibleEvents(records, todayKey) {
    var today = parseISODate(todayKey);
    if (!today) return [];
    return records.filter(function (event) {
      return validEvent(event) && (event.date < todayKey || inDisplayWindow(event, today.day));
    }).slice().sort(function (a, b) {
      return a.date.localeCompare(b.date) || a.order - b.order || a.id.localeCompare(b.id);
    });
  }

  function syncImage(root, event, image, source) {
    if (!image) return;
    var desktop = root.getAttribute('data-image-' + event.imageKey + '-desktop') || '';
    var mobile = root.getAttribute('data-image-' + event.imageKey + '-mobile') || desktop;
    image.setAttribute('alt', event.imageAlt);
    var media = image.closest ? image.closest('[data-qy-observance-media]') : null;
    var note = media && media.querySelector('[data-qy-image-fallback]');
    function show(loaded) {
      // Keep the layout box so native lazy loading can start; never show the previous image.
      image.hidden = false;
      if (image.style) image.style.opacity = loaded ? '1' : '0';
      if (note) note.hidden = loaded;
    }
    if (!image.__qyImageListeners && image.addEventListener) {
      image.addEventListener('load', function () { show(image.naturalWidth > 0); });
      image.addEventListener('error', function () { show(false); image.hidden = true; });
      image.__qyImageListeners = true;
    }
    var key = desktop + '|' + mobile;
    if (image.__qyImageKey === key) return;
    image.__qyImageKey = key;
    show(false);
    if (source) source.setAttribute('srcset', mobile);
    if (desktop) image.setAttribute('src', desktop);
    else image.removeAttribute('src');
    if (image.complete && image.naturalWidth > 0) show(true);
  }

  function formatDate(value) {
    var parsed = parseISODate(value);
    if (!parsed) return '';
    return new Intl.DateTimeFormat('en-US', {
      timeZone: 'UTC',
      month: 'long',
      day: 'numeric',
      year: 'numeric',
    }).format(new Date(parsed.utcMs));
  }

  function shanghaiStartMs(value) {
    var parsed = parseISODate(value);
    return parsed ? parsed.utcMs - SHANGHAI_OFFSET_MS : NaN;
  }

  function countdownTo(event, now) {
    if (!event) return null;
    var target = shanghaiStartMs(event.date);
    var current = now instanceof Date ? now.getTime() : new Date(now === undefined ? Date.now() : now).getTime();
    if (!Number.isFinite(target) || !Number.isFinite(current)) return null;
    var diff = Math.max(0, target - current);
    return {
      totalMs: diff,
      days: Math.floor(diff / DAY_IN_MS),
      hours: Math.floor((diff % DAY_IN_MS) / (60 * 60 * 1000)),
      minutes: Math.floor((diff % (60 * 60 * 1000)) / (60 * 1000)),
    };
  }

  var events = SCHEDULE.map(function (row, index) {
    var type = TYPES[row[1]];
    var settings = row[4] || {};
    return Object.freeze({
      id: row[0],
      type: row[1],
      year: Number(row[2].slice(0, 4)),
      date: row[2],
      lunarNote: row[3],
      englishTitle: type.englishTitle,
      chineseTitle: type.chineseTitle,
      introduction: type.introduction,
      imageKey: type.imageKey,
      imageAlt: type.imageAlt,
      primaryCtaLabel: type.primaryCtaLabel,
      primaryCtaUrl: type.articleUrl,
      secondaryCtaLabel: type.secondaryCtaLabel,
      secondaryCtaUrl: type.secondaryCtaUrl,
      enabled: settings.enabled !== false,
      displayStart: settings.displayStart || '',
      displayEnd: settings.displayEnd || '',
      order: Number.isFinite(settings.order) ? settings.order : index,
    });
  });

  global.QiyuanObservanceCalendar = Object.freeze({
    version: VERSION,
    timeZone: TIME_ZONE,
    coverage: Object.freeze({ startYear: 2026, endYear: 2030 }),
    events: Object.freeze(events),
    parseISODate: parseISODate,
    getTodayKey: getTodayKey,
    validEvent: validEvent,
    visibleEvents: visibleEvents,
    syncImage: syncImage,
    selectNextEvent: selectNextEvent,
    statusFor: statusFor,
    formatDate: formatDate,
    shanghaiStartMs: shanghaiStartMs,
    countdownTo: countdownTo,
  });
})(typeof globalThis !== 'undefined' ? globalThis : this);
